import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {ProductoPasarelaContrato} from '../_models/producto-pasarela-contrato';

@Injectable({
  providedIn: 'root'
})
export class ProductoPasarelaContratoService {
  private route: string = `${AppSettings.rutServiciosAPL}/api/productosPasarelasContratos`;

  constructor(
    private httpClient: HttpClient,
    private authService: AutenticacionService
  ) {}

  getAll(): Observable<ProductoPasarelaContrato[]> {
    return this.httpClient.get<ProductoPasarelaContrato[]>(this.route);
  }

  getAllEnabled(): Observable<ProductoPasarelaContrato[]> {
    return this.httpClient.get<ProductoPasarelaContrato[]>(`${this.route}/enabled}`);
  }

  getById(id: string): Observable<ProductoPasarelaContrato[]> {
    return this.httpClient.get<ProductoPasarelaContrato[]>(`${this.route}/${id}`);
  }

  getByIdProductoPasarela(id: string): Observable<ProductoPasarelaContrato[]> {
    return this.httpClient.get<ProductoPasarelaContrato[]>(`${this.route}/productoPasarela/${id}`);
  }

  getByIdProductoPasarelaEnabled(id: string): Observable<ProductoPasarelaContrato[]> {
    return this.httpClient.get<ProductoPasarelaContrato[]>(`${this.route}/productoPasarela/${id}/enabled`);
  }

  getByIdsProductosPasarela(ids: string[]): Observable<ProductoPasarelaContrato[]> {
    return this.httpClient.post<ProductoPasarelaContrato[]>(`${this.route}/idProductoPasarelaIn`, ids);
  }

  create(record: ProductoPasarelaContrato): Observable<ProductoPasarelaContrato> {
    record.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado();
    return this.httpClient.post<ProductoPasarelaContrato>(this.route, record);
  }

  update(record: ProductoPasarelaContrato): Observable<ProductoPasarelaContrato> {
    record.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado();
    return this.httpClient.put<ProductoPasarelaContrato>(this.route, record);
  }

  createBulk(records: ProductoPasarelaContrato[]): Observable<ProductoPasarelaContrato[]> {
    records.forEach((e: ProductoPasarelaContrato) => e.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado());
    return this.httpClient.post<ProductoPasarelaContrato[]>(`${this.route}/bulk`, records);
  }

  updateBulk(records: ProductoPasarelaContrato[]): Observable<ProductoPasarelaContrato[]> {
    records.forEach((e: ProductoPasarelaContrato) => e.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado());
    return this.httpClient.put<ProductoPasarelaContrato[]>(`${this.route}/bulk`, records);
  }
}
